module.exports = __webpack_public_path__ + "static/media/background3.7eabdfee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background3.jpg
// module id = 259
// module chunks = 0